export var CloudSyncStatus;
(function (CloudSyncStatus) {
    CloudSyncStatus[CloudSyncStatus["Initializing"] = 0] = "Initializing";
    CloudSyncStatus[CloudSyncStatus["Offline"] = 1] = "Offline";
    CloudSyncStatus[CloudSyncStatus["NotStarted"] = 2] = "NotStarted";
    CloudSyncStatus[CloudSyncStatus["Disabled"] = 3] = "Disabled";
    CloudSyncStatus[CloudSyncStatus["Synchronized"] = 4] = "Synchronized";
    CloudSyncStatus[CloudSyncStatus["InProgress"] = 5] = "InProgress";
    CloudSyncStatus[CloudSyncStatus["ErrorQuotaExceeded"] = 6] = "ErrorQuotaExceeded";
    CloudSyncStatus[CloudSyncStatus["ErrorSyncDown"] = 7] = "ErrorSyncDown";
    CloudSyncStatus[CloudSyncStatus["ErrorOther"] = 8] = "ErrorOther";
})(CloudSyncStatus || (CloudSyncStatus = {}));
